<div class="user-account-security-popup">
  @if (isLoading) {
    <div class="loading-state">
      <app-rings-loader class="bg-transparent"></app-rings-loader>
      <div class="loading-label">{{ 'Loading account security details...' | translate }}</div>
    </div>
  } @else {
    @if (viewModel) {
      <div class="flyout-head">
        <div class="flyout-head-title">
          <i class="material-icons">shield</i>
          <span>{{ 'Account Security' | translate }}</span>
        </div>
        <button type="button" class="flyout-close" (click)="closeFlyout()">
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="flyout-identity">
        <div class="avatar">{{ viewModel.avatarText }}</div>
        <div class="identity-copy">
          <div class="user-name">{{ viewModel.fullName }}</div>
          <div class="user-meta">
            <i class="material-icons">mail</i>
            <span>{{ viewModel.userName }}</span>
          </div>
          <div class="user-meta user-meta-secondary">
            <i class="material-icons">person</i>
            <span>{{ viewModel.roleName }}</span>
            @if (viewModel.jobTitle && viewModel.jobTitle !== '-') {
              <span>· {{ viewModel.jobTitle }}</span>
            }
          </div>
        </div>
      </div>
      <div class="flyout-body">
        <div class="section-title">
          <i class="material-icons">shield</i>
          <span>{{ 'Account Security' | translate }}</span>
        </div>
        <div class="details-section">
          <div class="detail-row">
            <div class="detail-label">{{ 'Last Login' | translate }}</div>
            <div class="detail-value detail-value-tabular" [class.detail-value-muted]="!viewModel.lastSuccessfulLogin">
              @if (viewModel.lastSuccessfulLogin) {
                {{ viewModel.lastSuccessfulLogin | dateFormat }}
              } @else {
                {{ 'Never' | translate }}
              }
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">{{ 'Login Method' | translate }}</div>
            <div class="detail-value" [class.detail-value-muted]="viewModel.loginMethod === '-'">
              {{ viewModel.loginMethod | translate }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">{{ 'Account Status' | translate }}</div>
            <div [class]="viewModel.accountStatusClass">{{ viewModel.accountStatusLabel | translate }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">{{ 'Lock State' | translate }}</div>
            <div [class]="viewModel.lockStateClass">{{ viewModel.lockStateLabel | translate }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-label">{{ 'Last Status Change' | translate }}</div>
            <div class="detail-value detail-value-tabular" [class.detail-value-muted]="!viewModel.lastStatusChangedAt">
              @if (viewModel.lastStatusChangedAt) {
                @if (viewModel.lastStatusChangedBy) {
                  {{ viewModel.lastStatusChangePrefix | translate }} {{ viewModel.lastStatusChangedBy }} &middot; {{ viewModel.lastStatusChangedAt | dateFormat }}
                } @else {
                  {{ viewModel.lastStatusChangedAt | dateFormat }}
                }
              } @else {
                -
              }
            </div>
          </div>
        </div>
      </div>
      <div class="flyout-foot">
        <div class="actions-section">
          @if (viewModel.showDisableButton) {
            <button
              class="btn btn-danger"
              [disabled]="viewModel.disableButtonDisabled"
              (click)="openDisableConfirmDialog()"
              >
              <i class="material-icons">block</i>
              {{ 'Disable' | translate }}
            </button>
          }
          @if (viewModel.showEnableButton) {
            <button
              class="btn btn-primary"
              [disabled]="viewModel.enableButtonDisabled"
              (click)="openEnableConfirmDialog()"
              >
              <i class="material-icons">check_circle</i>
              {{ 'Enable' | translate }}
            </button>
          }
          @if (viewModel.showUnlockButton) {
            <button
              class="btn btn-outline"
              (click)="openUnlockConfirmDialog()"
              >
              <i class="material-icons">lock_open</i>
              {{ 'Unlock' | translate }}
            </button>
          }
        </div>
        @if (viewModel.lockoutNote) {
          <div class="action-note action-note-warning">
            <i class="material-icons">warning</i>
            <span>{{ viewModel.lockoutNote | translate }}</span>
          </div>
        }
        @if (viewModel.footerNote) {
          <div class="action-note">
            <i class="material-icons">info</i>
            <span>{{ viewModel.footerNote | translate }}</span>
          </div>
        }
      </div>
    } @else {
      <div class="empty-state">{{ 'No account security details available.' | translate }}</div>
    }
  }


</div>
